import isEmpty from 'lodash/isEmpty';

type AcceptedType = object | string | undefined | null;

export const notEmpty = <T extends AcceptedType>(value: T): value is NonNullable<typeof value> =>
  !isEmpty(value);
